const typeEnum = {
    3: '商品订单',
    4: '服务工单',
    6: '客户报事',
    7: '员工报事',
    8: '监控预警',
    10: '客户投诉',
    11: '计划性工单',
};

export default function workOrderType(typeEnumIndex) {
    return typeEnum[Number.parseInt(typeEnumIndex)] || '未知类型'
}
